import * as React from "react";

import { MetaTags } from "../../../head";
import { Overlay } from "../../../components";
import http from "../../../helpers/http";
import * as constants from "../constants";

import LandingPage from "./LandingPage";
import SubscriptionForm, { SubscriptionFormValues } from "./SubscriptionForm";
import MarketingForm, { MarketingFormValues } from "./MarketingForm";

export interface LandingPageContainerProps {}

export interface LandingPageContainerState {
  showSubscriptionBox: boolean;
  showMarketingPopup: boolean;
}

class LandingPageContainer extends React.Component<
  LandingPageContainerProps,
  LandingPageContainerState
> {
  public state: LandingPageContainerState = {
    showSubscriptionBox: false,
    showMarketingPopup: false,
  };

  private handleCloseSubscriptionBox = () =>
    this.setState(state => ({
      ...state,
      showSubscriptionBox: false,
    }));

  private handleCloseMarketingPopup = () =>
    this.setState(state => ({
      ...state,
      showMarketingPopup: false,
    }));

  private handleSubcriptionSubmit = async (values: SubscriptionFormValues) => {
    const { success }: any = await http.post(
      constants.FORMSPREE_SUBSCRIPTION_ACTION,
      values,
    );
    if (success) {
      this.handleCloseSubscriptionBox();
    }
  };

  private handleMarketingSubmit = async (values: MarketingFormValues) => {
    const { success }: any = await http.post(
      constants.FORMSPREE_SUBSCRIPTION_ACTION,
      values,
    );
    if (success) {
      this.handleCloseMarketingPopup();
    }
  };

  public render(): any {
    const shadow = [
      <MetaTags key={0} title="Trang chủ" />,
      <LandingPage key={1} />,
    ];

    if (this.state.showSubscriptionBox) {
      shadow.push(
        <Overlay key={2}>
          <SubscriptionForm
            onClose={this.handleCloseSubscriptionBox}
            onSubmit={this.handleSubcriptionSubmit}
            initialValues={{
              source: "SUBSCRIPTION_BOX",
            }}
          />
        </Overlay>,
      );
    }

    if (this.state.showMarketingPopup) {
      shadow.push(
        <MarketingForm
          key={3}
          isOpen={this.state.showMarketingPopup}
          onClose={this.handleCloseMarketingPopup}
          onSubmit={this.handleMarketingSubmit}
          initialValues={{
            source: "MARKETING_POPUP",
          }}
        />,
      );
    }

    return shadow;
  }
}

export default LandingPageContainer;



// WEBPACK FOOTER //
// ./src/routes/LandingPage/components/LandingPageContainer.tsx